import { __extends } from "tslib";
import { BaseSelectAdapter } from '../core/base-select-adapter';
var SelectDropdownAdapter = /** @class */ (function (_super) {
    __extends(SelectDropdownAdapter, _super);
    function SelectDropdownAdapter(component) {
        return _super.call(this, component) || this;
    }
    SelectDropdownAdapter.prototype.initializeAccessibility = function () {
        this._targetElement.setAttribute('role', 'listbox');
        this._targetElement.setAttribute('aria-live', 'polite');
        this._targetElement.setAttribute('aria-haspopup', 'true');
        this._targetElement.setAttribute('aria-expanded', 'false');
    };
    SelectDropdownAdapter.prototype.addClickListener = function (listener) {
        this._targetElement.addEventListener('click', listener);
    };
    SelectDropdownAdapter.prototype.removeClickListener = function (listener) {
        if (this._targetElement) {
            this._targetElement.removeEventListener('click', listener);
        }
    };
    SelectDropdownAdapter.prototype.addTargetListener = function (type, listener) {
        var passive;
        var capture;
        if (type === 'keydown') {
            // We don't use a passive keydown listener because we are preventing default in this event and Angular doesn't like that
            // We need to use capturing to ensure that we get to this event before zone.js does
            passive = false;
            capture = true;
        }
        this._targetElement.addEventListener(type, listener, { passive: passive, capture: capture });
    };
    SelectDropdownAdapter.prototype.removeTargetListener = function (type, listener) {
        if (this._targetElement) {
            this._targetElement.removeEventListener(type, listener);
        }
    };
    SelectDropdownAdapter.prototype.updateActiveDescendant = function (id) {
        if (id) {
            this._targetElement.setAttribute('aria-activedescendant', id);
        }
        else {
            this._targetElement.removeAttribute('aria-activedescendant');
        }
    };
    SelectDropdownAdapter.prototype.open = function (config) {
        _super.prototype.open.call(this, config);
        this._targetElement.setAttribute('aria-controls', "list-dropdown-popup-" + config.id);
        this._targetElement.setAttribute('aria-expanded', 'true');
    };
    SelectDropdownAdapter.prototype.close = function () {
        this._targetElement.setAttribute('aria-expanded', 'false');
        this._targetElement.removeAttribute('aria-activedescendant');
        this._targetElement.removeAttribute('aria-controls');
        _super.prototype.close.call(this);
    };
    SelectDropdownAdapter.prototype.attach = function (selector) {
        var rootNode = this._component.getRootNode() || HTMLDocument;
        var doc = rootNode || this._component.ownerDocument || document;
        var element = doc.querySelector(selector);
        if (element) {
            this._targetElement = element;
        }
    };
    SelectDropdownAdapter.prototype.detach = function () {
        this._targetElement = undefined;
    };
    SelectDropdownAdapter.prototype.setMultiple = function (multiple) {
        if (!this._targetElement) {
            return;
        }
        if (multiple) {
            this._targetElement.setAttribute('aria-multiselectable', 'true');
        }
        else {
            this._targetElement.removeAttribute('aria-multiselectable');
        }
    };
    SelectDropdownAdapter.prototype.setTargetDisconnectedListener = function (cb) {
        var _this = this;
        if (!this._targetElement || !this._targetElement.parentElement) {
            return function () { };
        }
        var observer = new MutationObserver(function (mutations) {
            var isTargetRemoved = mutations.some(function (mutation) {
                return Array.from(mutation.removedNodes).some(function (node) { return node === _this._targetElement; });
            });
            if (isTargetRemoved) {
                observer.disconnect();
                cb();
            }
        });
        observer.observe(this._targetElement.parentElement, { childList: true });
        return function () { return observer.disconnect(); };
    };
    SelectDropdownAdapter.prototype.isAttached = function () {
        return !!this._targetElement;
    };
    SelectDropdownAdapter.prototype.setTargetText = function (text, selector) {
        var target = this._targetElement;
        if (selector) {
            var element = this._getElementBySelector(selector);
            if (element) {
                target = element;
            }
        }
        if (target) {
            target.textContent = text;
        }
    };
    SelectDropdownAdapter.prototype.getTargetText = function (selector) {
        var element = selector ? this._getElementBySelector(selector) : this._targetElement;
        return element ? element.innerText : '';
    };
    SelectDropdownAdapter.prototype._getElementBySelector = function (selector) {
        return this._targetElement.querySelector(selector) || this._getRootNode().querySelector(selector);
    };
    SelectDropdownAdapter.prototype._getRootNode = function () {
        return this._component.getRootNode() || this._component.ownerDocument || document;
    };
    return SelectDropdownAdapter;
}(BaseSelectAdapter));
export { SelectDropdownAdapter };
